import { Activity, ShoppingCart, Building2, Factory, ShoppingBag, Zap, Shield, Leaf, Award, Clock, Users } from 'lucide-react';
import React from 'react';

export const segmentConfigs = {
  hospital: {
    segmentName: "Hospitais e Clínicas",
    segmentSlug: "hospital",
    segmentIcon: <Activity className="w-5 h-5" />,
    metaTitle: "Locação de Lavadora de Piso para Hospitais e Clínicas | Higiene Hospitalar | WellTec",
    metaDescription: "Locação de lavadora de piso para hospitais e clínicas em BH e MG. Equipamentos específicos para ambiente hospitalar. Higiene e segurança garantidas. ☎ (31) 97182-3249",
    heroSubtitle: "Soluções especializadas em limpeza hospitalar com equipamentos que atendem às rigorosas normas de higiene e segurança de hospitais e clínicas.",
    geoBlockTitle: "Locação para Hospitais - Higiene e Segurança Hospitalar",
    geoBlockContent: "A locação de lavadoras de piso para hospitais e clínicas requer equipamentos específicos que atendam às rigorosas normas de higiene hospitalar (ANVISA, NR 32). A WellTec oferece lavadoras com sistema de filtragem HEPA para ambientes sensíveis, baixo nível de ruído para não incomodar pacientes, operação a bateria (zero emissões) para ambientes fechados, tanques separados para água limpa e suja, compatibilidade com produtos hospitalares específicos e manutenção preventiva rigorosa. Atendemos hospitais, clínicas, laboratórios, centros cirúrgicos, UTIs e áreas administrativas com treinamento especializado em higiene hospitalar e suporte técnico que entende as necessidades do setor de saúde. Equipamento reserva garantido para não comprometer a higienização.",
    benefits: [
      { icon: <Shield className="w-8 h-8" />, title: "Normas ANVISA", desc: "Equipamentos conformes" },
      { icon: <Leaf className="w-8 h-8" />, title: "Zero Emissões", desc: "Lavadoras a bateria" },
      { icon: <Activity className="w-8 h-8" />, title: "Baixo Ruído", desc: "Não incomoda pacientes" },
      { icon: <Award className="w-8 h-8" />, title: "Higiene Garantida", desc: "Filtros HEPA" }
    ],
    equipmentRecommendations: [
      { name: "Lavadoras a Bateria", desc: "Zero emissões, ideais para ambientes fechados e áreas sensíveis" },
      { name: "Filtros HEPA", desc: "Retenção de partículas para ambientes hospitalares críticos" },
      { name: "Modelos Silenciosos", desc: "Baixo nível de ruído para não incomodar pacientes" }
    ],
    faqItems: [
      {
        question: "As lavadoras atendem normas da ANVISA?",
        answer: "Sim! Nossos equipamentos são apropriados para ambiente hospitalar e atendem normas de higiene e segurança. Oferecemos lavadoras com filtros HEPA, tanques separados e compatibilidade com produtos hospitalares."
      },
      {
        question: "Posso usar em áreas sensíveis como UTI?",
        answer: "Sim! Oferecemos lavadoras silenciosas, com zero emissões (bateria) e filtros HEPA específicas para áreas críticas. Recomendamos agendamento de limpeza em horários estratégicos."
      },
      {
        question: "Qual o treinamento oferecido?",
        answer: "Treinamento especializado em higiene hospitalar: uso correto de produtos químicos, técnicas de limpeza para áreas críticas, normas de segurança e biossegurança. Certificado de treinamento incluso."
      },
      {
        question: "Vocês atendem hospitais em BH e região?",
        answer: "Sim! Atendemos hospitais em toda região metropolitana de BH (Santa Casa, Mater Dei, Felício Rocho, Life Center) e interior de MG com suporte técnico prioritário."
      }
    ],
    relatedPages: [
      { name: "Locação em BH", url: "/locacao-lavadora-piso-belo-horizonte" },
      { name: "Locação em Contagem", url: "/locacao-lavadora-piso-contagem" },
      { name: "Locação para Clínicas", url: "/locacao-lavadora-piso" }
    ]
  },

  supermercado: {
    segmentName: "Supermercados",
    segmentSlug: "supermercado",
    segmentIcon: <ShoppingCart className="w-5 h-5" />,
    metaTitle: "Locação de Lavadora de Piso para Supermercados | Limpeza de Piso Comercial | WellTec",
    metaDescription: "Locação de lavadora de piso para supermercados em BH e MG. Limpeza eficiente em horários de funcionamento. Manutenção inclusa. ☎ (31) 97182-3249",
    heroSubtitle: "Equipamentos ideais para supermercados com operação durante horário de funcionamento, limpeza rápida e eficiente de corredores e áreas de alto tráfego.",
    geoBlockTitle: "Locação para Supermercados - Limpeza Durante Operação",
    geoBlockContent: "A locação de lavadoras de piso para supermercados exige equipamentos que operem durante o horário de funcionamento sem comprometer a circulação de clientes. A WellTec oferece lavadoras pedestres compactas e manobráveis para corredores, secagem rápida do piso (segurança para clientes), baixo nível de ruído para não incomodar, operação a bateria (sem cabos para tropeço) e alta produtividade para limpeza entre turnos. Atendemos supermercados de todos os portes em BH, Contagem e região com lavadoras para áreas de vendas, câmaras frias, estoque e estacionamento. Manutenção preventiva programada fora do horário de pico e equipamento reserva garantido. Ideal para redes como EPA, Verdemar, Carrefour, Extra e supermercados independentes.",
    benefits: [
      { icon: <Clock className="w-8 h-8" />, title: "Limpeza Rápida", desc: "Secagem em minutos" },
      { icon: <Users className="w-8 h-8" />, title: "Segurança", desc: "Sem riscos para clientes" },
      { icon: <Zap className="w-8 h-8" />, title: "Alta Produtividade", desc: "Limpeza eficiente" },
      { icon: <Shield className="w-8 h-8" />, title: "Baixo Ruído", desc: "Não incomoda clientes" }
    ],
    equipmentRecommendations: [
      { name: "Lavadoras Pedestres", desc: "Compactas e manobráveis para corredores estreitos" },
      { name: "Secagem Rápida", desc: "Piso seco em 1-2 minutos para segurança de clientes" },
      { name: "Bateria de Longa Duração", desc: "Autonomia para limpeza completa sem recarga" }
    ],
    faqItems: [
      {
        question: "Posso usar durante horário de funcionamento?",
        answer: "Sim! Nossas lavadoras são projetadas para operação durante funcionamento: silenciosas, secagem rápida do piso, sem cabos (bateria) e compactas para não bloquear corredores."
      },
      {
        question: "Qual equipamento ideal para supermercado?",
        answer: "Para supermercados, recomendamos lavadoras pedestres de 45-60cm de largura, com secagem rápida e bateria. Para grandes redes com área acima de 2.000m², lavadoras tripuladas para limpeza noturna."
      },
      {
        question: "Quanto tempo leva para limpar um supermercado?",
        answer: "Depende do tamanho: Pequeno (até 500m²): 30-45 min; Médio (500-1500m²): 1-2h; Grande (acima de 1500m²): 2-4h. Com lavadora industrial, a produtividade é 5x maior que limpeza manual."
      }
    ],
    relatedPages: [
      { name: "Locação em BH", url: "/locacao-lavadora-piso-belo-horizonte" },
      { name: "Locação em Contagem", url: "/locacao-lavadora-piso-contagem" },
      { name: "Locação para Shoppings", url: "/locacao-lavadora-piso-shopping" }
    ]
  },

  condominio: {
    segmentName: "Condomínios",
    segmentSlug: "condominio",
    segmentIcon: <Building2 className="w-5 h-5" />,
    metaTitle: "Locação de Lavadora de Piso para Condomínios | Limpeza de Áreas Comuns | WellTec",
    metaDescription: "Locação de lavadora de piso para condomínios residenciais e comerciais em BH e MG. Equipamentos silenciosos. Manutenção inclusa. ☎ (31) 97182-3249",
    heroSubtitle: "Soluções para condomínios residenciais e comerciais com equipamentos silenciosos, operação flexível e atendimento discreto para áreas comuns.",
    geoBlockTitle: "Locação para Condomínios - Limpeza de Áreas Comuns",
    geoBlockContent: "A locação de lavadoras de piso para condomínios oferece soluções para limpeza de áreas comuns: garagens, saguões, salões de festa, academias, piscinas (área externa), calçadas e portarias. A WellTec fornece lavadoras silenciosas para não incomodar moradores, equipamentos compactos para elevadores e acessos, operação a bateria (sem cabos), horários flexíveis (diurno ou noturno) e atendimento discreto e profissional. Atendemos condomínios residenciais e comerciais em BH (Savassi, Lourdes, Funcionários), Contagem, Betim, Nova Lima (Vila da Serra, Alphaville) com treinamento para equipes de limpeza e manutenção programada para não interferir na rotina. Contratos mensais flexíveis.",
    benefits: [
      { icon: <Shield className="w-8 h-8" />, title: "Equipamentos Silenciosos", desc: "Não incomoda moradores" },
      { icon: <Clock className="w-8 h-8" />, title: "Horários Flexíveis", desc: "Diurno ou noturno" },
      { icon: <Users className="w-8 h-8" />, title: "Atendimento Discreto", desc: "Profissional e respeitoso" },
      { icon: <Award className="w-8 h-8" />, title: "Manutenção Inclusa", desc: "Sem custos extras" }
    ],
    equipmentRecommendations: [
      { name: "Lavadoras Silenciosas", desc: "Baixo nível de ruído para uso em horários sensíveis" },
      { name: "Modelos Compactos", desc: "Fácil transporte por elevadores e acessos" },
      { name: "Lavadoras a Bateria", desc: "Sem cabos, ideais para áreas comuns" }
    ],
    faqItems: [
      {
        question: "Os equipamentos são silenciosos?",
        answer: "Sim! Oferecemos lavadoras com baixo nível de ruído (60-65 dB), ideais para uso em condomínios residenciais em qualquer horário sem incomodar moradores."
      },
      {
        question: "Posso usar em garagem de condomínio?",
        answer: "Sim! Lavadoras de piso são ideais para garagens de condomínios. Limpam profundamente removendo óleo, sujeira e manchas que vassoura e água não removem."
      },
      {
        question: "Qual o custo para condomínio pequeno?",
        answer: "Para condomínios pequenos (até 1000m² de área comum), a locação mensal fica entre R$ 800 e R$ 1.200. Para condomínios maiores, oferecemos condições especiais. Solicite orçamento."
      }
    ],
    relatedPages: [
      { name: "Locação em Nova Lima", url: "/locacao-lavadora-piso-nova-lima" },
      { name: "Locação em BH", url: "/locacao-lavadora-piso-belo-horizonte" },
      { name: "Locação em Contagem", url: "/locacao-lavadora-piso-contagem" }
    ]
  },

  industria: {
    segmentName: "Indústrias",
    segmentSlug: "industria",
    segmentIcon: <Factory className="w-5 h-5" />,
    metaTitle: "Locação de Lavadora de Piso para Indústrias | Limpeza Industrial | WellTec",
    metaDescription: "Locação de lavadora de piso para indústrias em BH, Contagem e Betim. Equipamentos robustos para grandes áreas. Manutenção inclusa. ☎ (31) 97182-3249",
    heroSubtitle: "Equipamentos industriais de alta capacidade para grandes áreas fabris. Limpeza pesada, resistência e produtividade para ambiente industrial.",
    geoBlockTitle: "Locação para Indústrias - Limpeza Pesada e Alta Produtividade",
    geoBlockContent: "A locação de lavadoras de piso para indústrias atende ambientes fabris com alto nível de sujidade: óleo, graxa, resíduos de produção e poeira industrial. A WellTec oferece lavadoras tripuladas de alta capacidade (4.000-6.000 m²/hora), modelos robustos para limpeza pesada, varredeiras para pó e detritos, equipamentos a GLP para áreas externas e grandes espaços, lavadoras a bateria para áreas internas (zero emissões) e manutenção especializada em ambiente industrial. Atendemos indústrias em Contagem, Betim, Belo Horizonte e região com equipamento reserva garantido para não parar a limpeza, suporte técnico 24h e treinamento para operadores industriais. Ideal para indústrias automotivas, alimentícias, químicas, metalúrgicas, farmacêuticas e centros de distribuição.",
    benefits: [
      { icon: <Factory className="w-8 h-8" />, title: "Alta Capacidade", desc: "Até 6.000 m²/hora" },
      { icon: <Shield className="w-8 h-8" />, title: "Limpeza Pesada", desc: "Remove óleo e graxa" },
      { icon: <Award className="w-8 h-8" />, title: "Sem Paradas", desc: "Equipamento backup" },
      { icon: <Zap className="w-8 h-8" />, title: "Produtividade", desc: "Eficiência industrial" }
    ],
    equipmentRecommendations: [
      { name: "Lavadoras Tripuladas GLP", desc: "Máxima autonomia para grandes áreas industriais" },
      { name: "Lavadoras Tripuladas Bateria", desc: "Zero emissões para áreas internas fechadas" },
      { name: "Varredeiras Industriais", desc: "Remoção de detritos, pó e resíduos sólidos" }
    ],
    faqItems: [
      {
        question: "Qual equipamento ideal para indústria grande?",
        answer: "Para indústrias acima de 5.000m², recomendamos lavadoras tripuladas a GLP (áreas abertas) ou bateria (áreas fechadas) com capacidade de 4.000-6.000 m²/hora. Fazemos análise técnica gratuita."
      },
      {
        question: "Vocês atendem o polo industrial de Contagem e Betim?",
        answer: "Sim! Temos experiência atendendo indústrias automotivas, metalúrgicas e químicas em Contagem e Betim com equipamentos robustos e suporte técnico ágil."
      },
      {
        question: "A lavadora remove óleo e graxa industrial?",
        answer: "Sim! Com produtos químicos adequados (desengraxantes industriais), nossas lavadoras removem óleo, graxa e resíduos pesados. Recomendamos treinamento para uso correto de produtos."
      }
    ],
    relatedPages: [
      { name: "Locação em Contagem", url: "/locacao-lavadora-piso-contagem" },
      { name: "Locação em Betim", url: "/locacao-lavadora-piso-betim" },
      { name: "Locação em BH", url: "/locacao-lavadora-piso-belo-horizonte" }
    ]
  },

  shopping: {
    segmentName: "Shopping Centers",
    segmentSlug: "shopping",
    segmentIcon: <ShoppingBag className="w-5 h-5" />,
    metaTitle: "Locação de Lavadora de Piso para Shopping Centers | Limpeza de Shoppings | WellTec",
    metaDescription: "Locação de lavadora de piso para shopping centers em BH e MG. Limpeza noturna, equipamentos silenciosos. Manutenção inclusa. ☎ (31) 97182-3249",
    heroSubtitle: "Soluções para shopping centers com limpeza noturna eficiente, equipamentos de alta produtividade e operação silenciosa para não comprometer a experiência dos clientes.",
    geoBlockTitle: "Locação para Shopping Centers - Limpeza Profissional",
    geoBlockContent: "A locação de lavadoras de piso para shopping centers requer equipamentos de alta produtividade para limpeza noturna de grandes áreas em poucas horas. A WellTec oferece lavadoras tripuladas para corredores e praças de alimentação, lavadoras pedestres para lojas e áreas menores, varredeiras para estacionamentos, equipamentos silenciosos para limpeza durante funcionamento (emergências) e secagem rápida para abertura matinal. Atendemos shopping centers em BH (BH Shopping, Diamond Mall, Del Rey, Cidade), Contagem (Contagem Shopping) e região com manutenção preventiva em horários estratégicos, equipamento reserva garantido e treinamento especializado para equipes de facility. Contratos de longo prazo com condições especiais.",
    benefits: [
      { icon: <Zap className="w-8 h-8" />, title: "Alta Produtividade", desc: "Limpeza rápida noturna" },
      { icon: <Clock className="w-8 h-8" />, title: "Secagem Rápida", desc: "Pronto para abertura" },
      { icon: <Shield className="w-8 h-8" />, title: "Equipamentos Modernos", desc: "Tecnologia de ponta" },
      { icon: <Award className="w-8 h-8" />, title: "Suporte 24h", desc: "Atendimento noturno" }
    ],
    equipmentRecommendations: [
      { name: "Lavadoras Tripuladas", desc: "Alta produtividade para grandes áreas em poucas horas" },
      { name: "Lavadoras Pedestres", desc: "Para lojas, corredores estreitos e áreas específicas" },
      { name: "Varredeiras", desc: "Limpeza de estacionamentos e áreas externas" }
    ],
    faqItems: [
      {
        question: "Vocês fazem limpeza noturna em shoppings?",
        answer: "Sim! Nossos equipamentos são ideais para limpeza noturna de shoppings: alta produtividade (limpeza completa em 2-4h), silenciosos (não incomodam segurança/lojistas) e secagem rápida."
      },
      {
        question: "Qual o tempo de limpeza de um shopping?",
        answer: "Depende do tamanho: Shopping pequeno (até 10.000m²): 2-3h; Shopping médio (10.000-30.000m²): 3-5h; Shopping grande (acima de 30.000m²): 5-8h com múltiplas lavadoras."
      },
      {
        question: "Vocês atendem shoppings em BH?",
        answer: "Sim! Atendemos BH Shopping, Diamond Mall, Del Rey Shopping, Cidade Shopping e outros shoppings da região metropolitana com suporte técnico prioritário 24h."
      }
    ],
    relatedPages: [
      { name: "Locação em BH", url: "/locacao-lavadora-piso-belo-horizonte" },
      { name: "Locação em Contagem", url: "/locacao-lavadora-piso-contagem" },
      { name: "Locação para Supermercados", url: "/locacao-lavadora-piso-supermercado" }
    ]
  }
};

export default segmentConfigs;
